import { ref } from 'vue'

export interface ConfirmOptions {
	title?: string
	message: string
	confirmText?: string
	cancelText?: string
	type?: 'info' | 'warning' | 'error' | 'success'
}

const showDialog = ref(false)
const dialogOptions = ref<ConfirmOptions>({
	message: ''
})
let resolvePromise: ((value: boolean) => void) | null = null

export function useConfirm() {
	const confirm = (options: ConfirmOptions): Promise<boolean> => {
		dialogOptions.value = {
			title: options.title || 'Confirm',
			message: options.message,
			confirmText: options.confirmText || 'Confirm',
			cancelText: options.cancelText || 'Cancel',
			type: options.type || 'info'
		}
		
		showDialog.value = true
		
		return new Promise<boolean>((resolve) => {
			resolvePromise = resolve
		})
	}
	
	const handleConfirm = () => {
		showDialog.value = false
		if (resolvePromise) {
			resolvePromise(true)
			resolvePromise = null
		}
	}
	
	const handleCancel = () => {
		showDialog.value = false
		if (resolvePromise) {
			resolvePromise(false)
			resolvePromise = null
		}
	}
	
	return {
		showDialog,
		dialogOptions,
		confirm,
		handleConfirm,
		handleCancel
	}
}

